<template>
  <div class="embed-container">
    <iframe
      id="youtube-player"
      frameborder="0"
      allowfullscreen="1"
      :src="videoUrl"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  name: 'youtube',
  props: ['videoId', 'playerVars'],
  computed: {
    videoUrl() {
      return `https://www.youtube.com/embed/${this.videoId}?start=${this.playerVars.start}&amp;end=${this.playerVars.end}&amp;autoplay=${this.playerVars.autoplay}&amp;showinfo=${this.playerVars.showinfo}&amp;autohide=${this.playerVars.autohide}&amp;rel=0`;
    }
  }
};
</script>

<style scoped>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
